export const ENTITY_LIST_PANEL_LABELS = {
  emptyDescription: 'Try adjusting your search or filter.',
  emptyTitle: 'No items found',
  errorDescription: 'Please refresh the page or try again.',
  errorTitle: 'Unable to load items',
  filter: 'Filter',
  filterSearchPlaceholder: 'Find Option',
  emptyFilterOptions: 'No options found',
  searchPlaceholder: 'Search',
  scrollHintItemSingular: 'item',
  scrollHintItemPlural: 'items',
} as const;

export const ENTITY_LIST_PANEL_SKELETON_ITEM_COUNT = 7;
